module.exports = __webpack_public_path__ + "static/small-group-training.0da18864.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients/small-group-training.jpg
// module id = 73
// module chunks = 253514110161907 263791100135453 269829036549620